export * from './DetailsListCard'
export { default as DetailsListCard } from './DetailsListCard'
